import type { DocumentSize } from './config';

/**
 * Document size dimensions configuration
 * Maps document sizes to their dimensions in pixels and grid cell size
 */
export const DOCUMENT_SIZE_DIMENSIONS = {
  '8.5"x11"': {
    width: 612, // 8.5 inches × 72 dpi
    height: 792, // 11 inches × 72 dpi
    /**
     * Grid cell size in pixels (12px × 12px)
     * Divides the 612×792 canvas into a 51×66 grid of squares
     * Used for snapping widgets to grid and rendering the background grid pattern
     */
    gridCellSize: 12,
  },
} as const satisfies Record<DocumentSize, { width: number; height: number; gridCellSize: number }>;
